<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">期间</label>
            <span class="weui-form-preview__value">{{initData.cm_yearmonth}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户名称</label>
            <span class="weui-form-preview__value">{{initData.cu_name}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">业务员</label>
            <span class="weui-form-preview__value">{{initData.cu_sellername}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">币种</label>
            <span class="weui-form-preview__value">{{initData.cm_currency}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">应收总额（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.cm_end}}</span>
          </div>
        </div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label"></label>
            <em class="weui-form-preview__value">期初</em>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">预收（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.cm_begin_pre}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">应收（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.cm_begin_rec}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">应收-开票（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.cm_begin_bill}}</span>
          </div>
        </div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label"></label>
            <em class="weui-form-preview__value">本期增加</em>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">预收（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.cm_add_pre}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">应收（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.cm_add_rec}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">应收-开票（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.cm_add_bill}}</span>
          </div>
        </div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label"></label>
            <em class="weui-form-preview__value">本期减少</em>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">预收（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.cm_reduce_pre}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">应收（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.cm_reduce_rec}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">应收-开票（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.cm_reduce_bill}}</span>
          </div>
        </div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label"></label>
            <em class="weui-form-preview__value">期末</em>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">预收（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.cm_end_pre}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">应收（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.cm_end_rec}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">应收-开票（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.cm_end_bill}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initData: Object
  }
};
</script>